import {useMutation} from '@apollo/react-hooks';
import type {FetchResult} from 'apollo-link';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SharedEmailAddressUpdate as UpdateSharedEmailAddressMutation,
    SharedEmailAddressUpdateVariables as UpdateSharedEmailAddressMutationVariables,
    SharedEmailAddressUpdateInput as UpdateSharedEmailAddressInput,
} from 'nutshell-graphql-types';

import UPDATE_SHARED_EMAIL_ADDRESS from '../mutations/update-shared-email-address.graphql';
import GET_SHARED_INBOX_CONFIG from '../queries/get-shared-inbox-config.graphql';

interface UseUpdateSharedEmailAddressReturn {
    updateSharedEmailAddress: (
        input: UpdateSharedEmailAddressInput
    ) => Promise<FetchResult<UpdateSharedEmailAddressMutation>>;
    isLoading: boolean;
    error: string | null | undefined;
}

export const useUpdateSharedEmailAddress = (): UseUpdateSharedEmailAddressReturn => {
    const [updateSharedEmailAddress, {loading, error}] = useMutation<
        UpdateSharedEmailAddressMutation,
        UpdateSharedEmailAddressMutationVariables
    >(UPDATE_SHARED_EMAIL_ADDRESS);

    return {
        updateSharedEmailAddress: (input: {id: string; displayName: string}) => {
            return updateSharedEmailAddress({
                variables: {input},
                awaitRefetchQueries: true,
                refetchQueries: [{query: GET_SHARED_INBOX_CONFIG}],
            });
        },
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
    };
};
